import { Ajax } from './axios';
// 报名
export default {
  // 分页获取邮寄列表
  expressListPost (param = {}) {
    return Ajax.post('/api/gugongExaminee/v1/express/list', { ...param });
  },
  // 获取邮寄详情
  expressDetailGet (examId) {
    return Ajax.get(`/api/gugongExaminee/v1/express/detail/${examId}`);
  },
  // 提交邮寄信息
  expressCommitPost (param = {}) {
    return Ajax.post(`/api/gugongExaminee/v1/express/commit`, { ...param });
  },
  // 更新邮寄信息
  expressUpdatePost (param = {}) {
    return Ajax.post(`/api/gugongExaminee/v1/express/update`, { ...param });
  }
};
